import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=f30ccd6c&"
import script from "./Tabs.vue?vue&type=script&lang=js&"
export * from "./Tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f30ccd6c')) {
      api.createRecord('f30ccd6c', component.options)
    } else {
      api.reload('f30ccd6c', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=f30ccd6c&", function () {
      api.rerender('f30ccd6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/Tabs.vue"
export default component.exports